// extracted by mini-css-extract-plugin
export var card = "_q1-0";
export var content = "_q1-2";
export var details = "_q1-3";
export var icon = "_q1-1";
export var iconBlue = "_q1-5";
export var iconBrand = "_q1-4";
export var iconGrayBlue = "_q1-6";
export var iconGreen = "_q1-7";
export var iconIndigo = "_q1-8";
export var iconOrange = "_q1-9";
export var iconPurple = "_q1-a";
export var iconRed = "_q1-b";
export var iconWarning = "_q1-c";